var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSalescaptain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 215,
    height: 150,
    viewBox: "0 0 215 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "b",
    width: 111.678,
    height: 49.113,
    rx: 1.692
  }), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: "106.3%",
    height: "114.3%",
    x: "-3.1%",
    y: "-5.1%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "c",
    cx: 63.795,
    cy: 63.795,
    r: 63.795
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(101.247 31.253)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 110.832,
    height: 48.267,
    x: 0.423,
    y: 0.423,
    fill: "#FFF",
    stroke: "#57B0EC",
    strokeLinejoin: "square",
    strokeWidth: 0.846,
    rx: 1.692
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(159.621 44.789)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#57B0EC",
    d: "M4.707.984l.415 1.162h1.039l-.935.563.363 1.182-.882-.659-.882.63.311-1.149-.882-.567h1.038zM4.707 5.635l.415 1.163h1.039l-.935.562.363 1.182-.882-.659-.882.63.311-1.148-.882-.567h1.038zM4.707 10.286l.415 1.163h1.039l-.935.562.363 1.182-.882-.658-.882.63.311-1.15-.882-.566h1.038zM4.707 14.937l.415 1.163h1.039l-.935.562.363 1.182-.882-.658-.882.63.311-1.15-.882-.566h1.038zM4.707 19.588l.415 1.163h1.039l-.935.562.363 1.182-.882-.658-.882.63.311-1.149-.882-.567h1.038z"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#57B0EC",
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 3.102,
    letterSpacing: -0.07
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0.092,
    y: 3.403
  }, "5")), /*#__PURE__*/React.createElement("text", {
    fill: "#57B0EC",
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 3.102,
    letterSpacing: -0.07
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 39.591,
    y: 3.403
  }, "180")), /*#__PURE__*/React.createElement("text", {
    fill: "#57B0EC",
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 3.102,
    letterSpacing: -0.07
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 39.664,
    y: 12.705
  }, "25")), /*#__PURE__*/React.createElement("text", {
    fill: "#57B0EC",
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 3.102,
    letterSpacing: -0.07
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0.092,
    y: 8.344
  }, "4")), /*#__PURE__*/React.createElement("text", {
    fill: "#57B0EC",
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 3.102,
    letterSpacing: -0.07
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0.092,
    y: 12.705
  }, "3")), /*#__PURE__*/React.createElement("text", {
    fill: "#57B0EC",
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 3.102,
    letterSpacing: -0.07
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 39.591,
    y: 8.344
  }, "150")), /*#__PURE__*/React.createElement("text", {
    fill: "#57B0EC",
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 3.102,
    letterSpacing: -0.07
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0.092,
    y: 17.647
  }, "2")), /*#__PURE__*/React.createElement("text", {
    fill: "#57B0EC",
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 3.102,
    letterSpacing: -0.07
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 39.664,
    y: 17.647
  }, "10")), /*#__PURE__*/React.createElement("text", {
    fill: "#57B0EC",
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 3.102,
    letterSpacing: -0.07
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0.092,
    y: 22.298
  }, "1")), /*#__PURE__*/React.createElement("text", {
    fill: "#57B0EC",
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 3.102,
    letterSpacing: -0.07
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 40.499,
    y: 22.298
  }, "5")), /*#__PURE__*/React.createElement("rect", {
    width: 30.523,
    height: 1.163,
    x: 7.614,
    y: 1.565,
    fill: "#DDE3E6",
    rx: 0.581
  }), /*#__PURE__*/React.createElement("rect", {
    width: 30.523,
    height: 1.163,
    x: 7.614,
    y: 6.507,
    fill: "#DDE3E6",
    rx: 0.581
  }), /*#__PURE__*/React.createElement("rect", {
    width: 30.523,
    height: 1.163,
    x: 7.614,
    y: 11.158,
    fill: "#DDE3E6",
    rx: 0.581
  }), /*#__PURE__*/React.createElement("rect", {
    width: 30.523,
    height: 1.163,
    x: 7.614,
    y: 15.809,
    fill: "#DDE3E6",
    rx: 0.581
  }), /*#__PURE__*/React.createElement("rect", {
    width: 30.523,
    height: 1.163,
    x: 7.614,
    y: 20.461,
    fill: "#DDE3E6",
    rx: 0.581
  }), /*#__PURE__*/React.createElement("rect", {
    width: 29.36,
    height: 1.163,
    x: 7.614,
    y: 1.565,
    fill: "#57B0EC",
    rx: 0.581
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24.709,
    height: 1.163,
    x: 7.614,
    y: 6.507,
    fill: "#57B0EC",
    rx: 0.581
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.174,
    height: 1.163,
    x: 7.614,
    y: 11.158,
    fill: "#57B0EC",
    rx: 0.581
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.907,
    height: 1.163,
    x: 7.614,
    y: 15.809,
    fill: "#57B0EC",
    rx: 0.581
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.453,
    height: 1.163,
    x: 7.614,
    y: 20.461,
    fill: "#57B0EC",
    rx: 0.581
  })), /*#__PURE__*/React.createElement("text", {
    fill: "#57B0EC",
    fontFamily: "Roboto-Light, Roboto",
    fontSize: 15.509,
    fontWeight: 300,
    letterSpacing: 0.169,
    transform: "translate(101.247 31.253)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 14.971,
    y: 22.883
  }, "4."), /*#__PURE__*/React.createElement("tspan", {
    x: 27.608,
    y: 22.883
  }, "8")), /*#__PURE__*/React.createElement("path", {
    fill: "#57B0EC",
    d: "M113.449 58.06l.685 1.744h1.713l-1.542.844.6 1.773-1.456-.988-1.456.944.514-1.722-1.456-.85h1.713zM119.553 58.06l.686 1.744h1.713l-1.542.844.6 1.773-1.457-.988-1.455.944.513-1.722-1.456-.85h1.713zM126.094 58.06l.685 1.744h1.713l-1.542.844.6 1.773-1.456-.988-1.456.944.514-1.722-1.456-.85h1.713zM132.635 58.06l.685 1.744h1.713l-1.542.844.6 1.773-1.456-.988-1.456.944.514-1.722-1.457-.85h1.714z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DDE3E6",
    d: "M139.902 58.06l.685 1.744h1.713l-1.541.844.599 1.773-1.456-.988-1.456.944.514-1.722-1.456-.85h1.713z",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#57B0EC",
    d: "M139.83 58.06v3.407l-1.589.954.56-1.74-1.588-.86h1.87z"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#57B0EC",
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 3.948,
    transform: "translate(101.247 31.253)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 15.184,
    y: 37.84
  }, "370 reviews")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.84 .107)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#ABD7F5",
    fillRule: "nonzero",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#d)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(76.407 31.146)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110.832,
    height: 48.267,
    x: 0.423,
    y: 0.423,
    stroke: "#FFF",
    strokeWidth: 0.846,
    rx: 1.692
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(52.029 13.536)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#57B0EC",
    d: "M4.707.984l.415 1.162h1.039l-.935.563.363 1.182-.882-.659-.882.63.311-1.149-.882-.567h1.038zM4.707 5.635l.415 1.163h1.039l-.935.562.363 1.182-.882-.659-.882.63.311-1.148-.882-.567h1.038zM4.707 10.286l.415 1.163h1.039l-.935.562.363 1.182-.882-.658-.882.63.311-1.15-.882-.566h1.038zM4.707 14.937l.415 1.163h1.039l-.935.562.363 1.182-.882-.658-.882.63.311-1.15-.882-.566h1.038zM4.707 19.588l.415 1.163h1.039l-.935.562.363 1.182-.882-.658-.882.63.311-1.149-.882-.567h1.038z"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#57B0EC",
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 3.102,
    letterSpacing: -0.07
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0.092,
    y: 3.403
  }, "5")), /*#__PURE__*/React.createElement("text", {
    fill: "#57B0EC",
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 3.102,
    letterSpacing: -0.07
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 39.591,
    y: 3.403
  }, "180")), /*#__PURE__*/React.createElement("text", {
    fill: "#57B0EC",
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 3.102,
    letterSpacing: -0.07
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 39.664,
    y: 12.705
  }, "25")), /*#__PURE__*/React.createElement("text", {
    fill: "#57B0EC",
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 3.102,
    letterSpacing: -0.07
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0.092,
    y: 8.344
  }, "4")), /*#__PURE__*/React.createElement("text", {
    fill: "#57B0EC",
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 3.102,
    letterSpacing: -0.07
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0.092,
    y: 12.705
  }, "3")), /*#__PURE__*/React.createElement("text", {
    fill: "#57B0EC",
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 3.102,
    letterSpacing: -0.07
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 39.591,
    y: 8.344
  }, "150")), /*#__PURE__*/React.createElement("text", {
    fill: "#57B0EC",
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 3.102,
    letterSpacing: -0.07
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0.092,
    y: 17.647
  }, "2")), /*#__PURE__*/React.createElement("text", {
    fill: "#57B0EC",
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 3.102,
    letterSpacing: -0.07
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 39.664,
    y: 17.647
  }, "10")), /*#__PURE__*/React.createElement("text", {
    fill: "#57B0EC",
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 3.102,
    letterSpacing: -0.07
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0.092,
    y: 22.298
  }, "1")), /*#__PURE__*/React.createElement("text", {
    fill: "#57B0EC",
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 3.102,
    letterSpacing: -0.07
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 40.499,
    y: 22.298
  }, "5")), /*#__PURE__*/React.createElement("rect", {
    width: 30.523,
    height: 1.163,
    x: 7.614,
    y: 1.565,
    fill: "#DDE3E6",
    rx: 0.581
  }), /*#__PURE__*/React.createElement("rect", {
    width: 30.523,
    height: 1.163,
    x: 7.614,
    y: 6.507,
    fill: "#DDE3E6",
    rx: 0.581
  }), /*#__PURE__*/React.createElement("rect", {
    width: 30.523,
    height: 1.163,
    x: 7.614,
    y: 11.158,
    fill: "#DDE3E6",
    rx: 0.581
  }), /*#__PURE__*/React.createElement("rect", {
    width: 30.523,
    height: 1.163,
    x: 7.614,
    y: 15.809,
    fill: "#DDE3E6",
    rx: 0.581
  }), /*#__PURE__*/React.createElement("rect", {
    width: 30.523,
    height: 1.163,
    x: 7.614,
    y: 20.461,
    fill: "#DDE3E6",
    rx: 0.581
  }), /*#__PURE__*/React.createElement("rect", {
    width: 29.36,
    height: 1.163,
    x: 7.614,
    y: 1.565,
    fill: "#57B0EC",
    rx: 0.581
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24.709,
    height: 1.163,
    x: 7.614,
    y: 6.507,
    fill: "#57B0EC",
    rx: 0.581
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.174,
    height: 1.163,
    x: 7.614,
    y: 11.158,
    fill: "#57B0EC",
    rx: 0.581
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.907,
    height: 1.163,
    x: 7.614,
    y: 15.809,
    fill: "#57B0EC",
    rx: 0.581
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.453,
    height: 1.163,
    x: 7.614,
    y: 20.461,
    fill: "#57B0EC",
    rx: 0.581
  })), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Roboto-Light, Roboto",
    fontSize: 15.509,
    fontWeight: 300,
    letterSpacing: 0.169
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 14.971,
    y: 22.883,
    fill: "#FFF"
  }, "4."), /*#__PURE__*/React.createElement("tspan", {
    x: 27.608,
    y: 22.883,
    fill: "#FFF"
  }, "8")), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.202 26.807l.685 1.744H14.6l-1.542.844.6 1.773-1.456-.988-1.456.944.514-1.722-1.456-.85h1.713zM18.306 26.807l.686 1.744h1.713l-1.542.844.6 1.773-1.457-.988-1.455.944.513-1.722-1.456-.85h1.713zM24.847 26.807l.685 1.744h1.713l-1.542.844.6 1.773-1.456-.988-1.456.944.514-1.722-1.456-.85h1.713zM31.388 26.807l.685 1.744h1.713l-1.542.844.6 1.773-1.456-.988-1.456.944.514-1.722-1.457-.85h1.714z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.655 26.807l.685 1.744h1.713l-1.541.844.599 1.773-1.456-.988-1.456.944.514-1.722-1.456-.85h1.713z",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 3.948
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 15.184,
    y: 37.84,
    fill: "#FFF"
  }, "370 reviews"))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 0.634,
    d: "M79.78 108.667v35.62h78.678V121.04c0-6.833-5.54-12.373-12.373-12.373H79.78z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.956 135.96v-2.567c0-.697-.583-1.262-1.303-1.262h-3.067v-1.473h3.317c1.439 0 2.605 1.13 2.605 2.525v2.987c0 1.395-1.166 2.525-2.605 2.525h-3.317v-1.473h3.067c.72 0 1.303-.565 1.303-1.262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.48 143.771h7.751c1.13 0 2.047-.934 2.047-2.086v-11.027h-11.844v11.027c0 1.152.916 2.086 2.047 2.086"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#DDE3E6",
    strokeLinecap: "round",
    strokeWidth: 0.634,
    d: "M.361 144.287h165.393"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    stroke: "#DFE7EB",
    strokeWidth: 0.846
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.532 136.91l-2.771.927c-.182.06-.354-.118-.295-.306l.893-2.874a12.046 12.046 0 0 1 2.821-4.788 11.473 11.473 0 0 1 4.617-2.926l2.771-.926c.182-.06.354.118.295.306l-.893 2.874a12.043 12.043 0 0 1-2.821 4.788 11.47 11.47 0 0 1-4.617 2.926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.972 135.503l.893 2.874c.059.188-.113.367-.295.306l-2.77-.926a11.472 11.472 0 0 1-4.618-2.926 12.047 12.047 0 0 1-2.821-4.788l-.893-2.874c-.059-.188.113-.367.295-.306l2.77.926a11.47 11.47 0 0 1 4.618 2.926 12.043 12.043 0 0 1 2.821 4.788"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.171 134.264l-1.301 2.61a.227.227 0 0 1-.409 0l-1.301-2.61a11.88 11.88 0 0 1-1.244-5.298c0-1.843.426-3.659 1.244-5.298l1.301-2.61a.227.227 0 0 1 .409 0l1.301 2.61a11.88 11.88 0 0 1 1.244 5.298 11.88 11.88 0 0 1-1.244 5.298"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M13.686 136.58v2.961a4.653 4.653 0 0 0 4.653 4.653h4.23a4.653 4.653 0 0 0 4.653-4.653v-2.961H13.686z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.489 62.555)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FC3",
    fillRule: "nonzero",
    d: "M17.953 36.745l15.284-2.399 16.03 2.427a6.98 6.98 0 0 1 5.934 6.9v35.85a6.98 6.98 0 0 1-6.979 6.979H19.035a6.98 6.98 0 0 1-6.98-6.98V43.64a6.98 6.98 0 0 1 5.898-6.895z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11.421,
    height: 44.523,
    x: 49.389,
    y: 36.955,
    fill: "#FC3",
    fillRule: "nonzero",
    rx: 5.71,
    transform: "rotate(-17 55.1 59.217)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11.421,
    height: 44.523,
    x: 6.345,
    y: 36.955,
    fill: "#FC3",
    fillRule: "nonzero",
    rx: 5.71,
    transform: "scale(-1 1) rotate(-17 0 139.882)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 44.415,
    height: 11.45,
    x: 21.89,
    y: 70.282,
    fill: "#FFF",
    fillRule: "nonzero",
    stroke: "#455B76",
    strokeWidth: 0.634,
    rx: 5.725
  }), /*#__PURE__*/React.createElement("rect", {
    width: 44.415,
    height: 11.45,
    x: 1.586,
    y: 70.282,
    fill: "#FFF",
    fillRule: "nonzero",
    stroke: "#455B76",
    strokeWidth: 0.634,
    rx: 5.725
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    stroke: "#DCE3E6",
    strokeWidth: 0.846,
    transform: "translate(9.729 52.792)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.032 33.815V3.89c0-1.914-1.561-3.467-3.489-3.467H4.17C2.243.423.68 1.976.68 3.89v29.925h47.35z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.557,
    cy: 17.119,
    fillRule: "nonzero",
    rx: 4.597,
    ry: 4.612
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero",
    stroke: "#455B76",
    strokeWidth: 0.634,
    transform: "translate(23.477)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.979,
    height: 10.814,
    x: 13.642,
    y: 4.134,
    rx: 3.49
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.863,
    height: 22.263,
    x: 0.317,
    y: 0.317,
    rx: 7.931
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero",
    stroke: "#455B76",
    strokeWidth: 0.634,
    transform: "translate(20.304 13.357)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.172,
    cy: 3.18,
    rx: 2.855,
    ry: 2.863
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.476,
    cy: 3.18,
    rx: 2.855,
    ry: 2.863
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    transform: "translate(27.918 19.081)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.152,
    height: 14.631,
    x: 0.317,
    y: 6.042,
    fill: "#FFF",
    stroke: "#455B76",
    strokeWidth: 0.634,
    rx: 5.076
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.787,
    height: 15.265,
    fill: "#455B76",
    rx: 5.393
  })), /*#__PURE__*/React.createElement("rect", {
    width: 19.669,
    height: 27.351,
    x: 23.794,
    y: 4.134,
    fill: "#FFF",
    fillRule: "nonzero",
    stroke: "#455B76",
    strokeWidth: 0.634,
    rx: 9.835
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    transform: "translate(28.552 10.813)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.952,
    cy: 4.134,
    fill: "#455B76",
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#455B76",
    strokeLinecap: "round",
    strokeWidth: 0.634,
    d: "M0 .636L2.202 0M8.345.125l1.826.637"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.2,
    cy: 4.134,
    fill: "#455B76",
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#455B76",
    strokeLinecap: "round",
    strokeWidth: 0.634,
    d: "M5.863 1.908v5.22H4.44M1.903 10.813c.64 1.304 4.327 1.622 5.613.716"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.07 89.627)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.419,
    height: 18.641,
    fill: "#FF5964",
    fillRule: "nonzero",
    rx: 9.32
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 0.846,
    d: "M12.839 6.768c-.939.01-1.561.853-1.63.965-.068-.112-.69-.955-1.628-.965-1.836-.02-2.774 2.161-1.079 4.11 1.035 1.188 2.707 1.812 2.707 1.812s1.673-.624 2.708-1.812c1.695-1.949.757-4.13-1.078-4.11"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalescaptain);
export default __webpack_public_path__ + "static/media/Salescaptain.185a7bed37fb4717115e6831265b1d48.svg";
export { ForwardRef as ReactComponent };